import React, { useEffect, useState, Fragment } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import classNames from 'classnames';

import pageLayout from 'HOC/pageLayout';
import PagesModule from 'modules/pages';
import PageTitle from 'components/PageTitle';
import Dropbox from 'components/Dropbox';
import Button from 'components/Button';


const Membership = props => {
  const { isAuth, isFetching, isFetched, getMembership, data } = props;
  const [id, setId] = useState();
  const [info, setInfo] = useState();
  const content = data?.content;
  const seo = data?.seo;
  const bannerText = data?.content?.header?.bannerText;

  const getInfo = () => {
    getMembership('membership');
  };

  useEffect(() => {
    getInfo();
  }, [id]);

  if (data && data.id !== id) {
    setId(data.id);
    setInfo({ ...data });
  }

  return (
    <>
      {
        seo &&
        <Helmet>
          <title>{seo.title}</title>
          <meta name="description" content={seo.description} />
          <meta name="keywords" content={seo.keywords}></meta>
          <meta property="og:title" content={seo.title} />
          <meta property="og:description" content={seo.description} />
          <meta property="og:site_name" content={process.env.REACT_APP_NAME} />
        </Helmet>
      }
      <div className="page-body">
        <PageTitle align="center">{bannerText}</PageTitle>

        {!content ? null : (
          <div className="content-container">
            <div className="container">
              <div className="row">
                <div className="col-12 col-lg-8 offset-lg-2">
                  {
                    content.main.list.map((listItem, index) => {
                      return (
                        <Fragment key={index}>
                          <div className="field-wrap">
                            <div className={classNames("section-title-lg", {
                              "section-title-lg--blue": listItem.is_main_category
                            })}>{listItem.title}</div>
                          </div>
                          {
                            listItem.list && listItem.list.map((item, index) => {
                              return (
                                <div className="form-section" key={index}>
                                  <Dropbox
                                    title={item.title}
                                    visible={false}
                                    isBordered={true}
                                    forForm={true}
                                    titleSize={item.is_subcategory ? "sm" : "lg"} >
                                    <div className="content-block">
                                      <div className="section-title-md">{item.description}</div>
                                      {item.data && (
                                        <div dangerouslySetInnerHTML={{
                                          __html: item.data
                                        }} />
                                      )}
                                    </div>
                                    {
                                      !isAuth &&
                                      <div className="field-wrap text-center">
                                        <Button bgColor="blue" to={item.link}>REGISTER HERE</Button>
                                      </div>
                                    }
                                  </Dropbox>
                                </div>
                              );
                            })
                          }
                        </Fragment>
                      );
                    })
                  }
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default compose(
  pageLayout(),
  connect(
    (state) => {
      return {
        isAuth: state.auth.isAuth,
        data: state.pages.membership,
        isFetching: state.pages.isFetching,
      }
    },
    {
      getMembership: PagesModule.fetch,
    }
  ),
)(Membership);
